import { FormattedMessage } from 'react-intl';
import { VisitDetailsWrapper } from './visit-modal.styles';

export const VisitModalError = (): JSX.Element => (
  <VisitDetailsWrapper>
    <FormattedMessage id="notifications.unableToFetchVisit" />
  </VisitDetailsWrapper>
);
